/**
 * section：Horiz Scroll Gallery
 * 独立版核心功能：GSAP 横向滚动图库（无Banner组件时单独使用）
 * 依赖：GSAP + ScrollTrigger + Lenis 平滑滚动
 * 保持与公用版完全一致的交互效果与性能
 * 终极修复：删除所有刷新监听，移动端零跳动、零刷新
 */
// ==================== 依赖引入（与原项目完全一致） ====================
import gsap from "https://cdn.shopify.com/s/files/1/0637/3297/3671/files/gsap.mjs?v=1775188103";
import { ScrollTrigger } from "https://cdn.shopify.com/s/files/1/0637/3297/3671/files/scrollTrigger.mjs?v=1775188103";
import Lenis from "https://cdn.shopify.com/s/files/1/0637/3297/3671/files/lenis.mjs";

// 注册GSAP插件
gsap.registerPlugin(ScrollTrigger);

// ==================== 全局变量 ====================
let lenis = null;

// ==================== 初始化Lenis平滑滚动（无修改） ====================
const initLenis = () => {
  lenis = new Lenis();

  lenis.on("scroll", ScrollTrigger.update);
  gsap.ticker.add((time) => {
    if (typeof lenis.raf === "function") {
      lenis.raf(time * 1000);
    }
  });
  gsap.ticker.lagSmoothing(0);
};

// ==================== 横向滚动核心逻辑（零刷新、零跳动） ====================
function initHorizontalGallery() {
  const galleries = document.querySelectorAll(".horiz-scroll-gallery");
  if (!galleries.length) return;

  galleries.forEach((gallery) => {
    const galleryWrapper = gallery.querySelector(".gallery-wrapper");
    const strip = gallery.querySelector(".horiz-gallery-strip");
    const pageWidthEl = document.querySelector(".page-width");

    if (!galleryWrapper || !strip || !pageWidthEl) return;

    // 仅页面加载时计算1次尺寸，永不更新
    const getScrollLength = () => {
      const windowWidth = window.innerWidth;
      const contentWidth = pageWidthEl.offsetWidth;
      const wrapWidth = strip.scrollWidth;
      const marginLeftValue = windowWidth < 990 ? 0 : (windowWidth - contentWidth) / 2;
      return Math.max(wrapWidth - windowWidth + marginLeftValue, 0);
    };

    // 固定尺寸，滚动时不改变
    const scrollLength = getScrollLength();
    const startPosition = "center center";

    // 关闭所有刷新、跳帧参数
    const scrollTriggerConfig = {
      trigger: gallery,
      pin: galleryWrapper,
      scrub: true,
      start: startPosition,
      end: `+=${scrollLength}`,
      invalidateOnRefresh: true,
      fastScrollEnd: true,
    };

    // 静态动画，无动态计算、无重绘
    gsap.to(strip, {
      x: -scrollLength,
      ease: "none",
      scrollTrigger: scrollTriggerConfig,
    });
  });
}

// ==================== 主入口函数 ====================
const init = async () => {
  await new Promise((resolve) => {
    if (document.readyState === "complete") resolve();
    else document.addEventListener("DOMContentLoaded", resolve);
  });

  initLenis();
  initHorizontalGallery();
};

init().catch((err) => {
  console.error("Horiz Scroll Gallery 初始化失败:", err);
});

// ==================== 页面卸载清理 ====================
window.addEventListener("beforeunload", () => {
  lenis?.destroy();
  ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
  gsap.ticker.removeAll();
});